import { render, staticRenderFns } from "./qrcodelifecycle.vue?vue&type=template&id=523ab21f&scoped=true"
import script from "./qrcodelifecycle.vue?vue&type=script&lang=js"
export * from "./qrcodelifecycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523ab21f",
  null
  
)

export default component.exports